import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
	icon: {
		height: '40px',
		filter: 'invert()',
		transition: theme.transitions.create(['transform', 'filter'], {
			duration: theme.transitions.duration.standard,
			easing: theme.transitions.easing.easeIn,
		}),
		margin: '0 auto',
		'&:hover': {
			transform: 'scale(1.1)',
			filter: 'invert(80%)',
		},
	},
	listContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		[theme.breakpoints.down('xs')]:{
			marginTop: '10px',
			flexWrap: 'wrap'
			
		}
		
	},
	tooltip: {
		fontFamily: 'Ubuntu'
	},
	selectLanguage:{
		backgroundColor: '#000',
		color:'#fff',
		border: 'none',
		cursor: 'pointer',
		WebkitAppearance: 'none',
		fontSize: '16px',
		wordSpacing: '5px',
		[theme.breakpoints.down('xs')]:{
			textAlign: 'center',
			marginBottom: '10px'
		}
	},
	socialMediaList:{
		flexBasis: '60px'
	}
}));
